import * as types from './types';

const INITIAL_STATE = {
    trips: {},
    tripItineraries: {},
    tripInformation: {},
};

function _setTripNotFound(state, action) {
    const {
        tripId,
    } = action.meta;

    return {
        ...state,
        trips: {
            ...state.trips,
            [tripId]: {
                notFound: true,
            },
        },
    };
}

function _setTrips(state, action) {
    const {
        payload: data,
    } = action;

    return {
        ...state,
        trips: {
            ...state.trips,
            ...data,
        },
    };
}

function _setTripItinerary(state, action) {
    const {
        tripId,
    } = action.meta;
    const data = action.payload;

    return {
        ...state,
        tripItineraries: {
            ...state.tripItineraries,
            [tripId]: data,
        },
    };
}

function _setTripInformation(state, action) {
    const {
        tripId,
    } = action.meta;
    const data = action.payload;

    return {
        ...state,
        tripInformation: {
            ...state.tripInformation,
            [tripId]: data,
        },
    };
}

function _updateTrip(state, action) {
    const {
        tripId,
    } = action.meta;

    return {
        ...state,
        trips: {
            ...state.trips,
            [tripId]: {
                ...state.trips[tripId],
                ...action.payload,
            },
        },
    };
}

function _removeTrip(state, action) {
    const {
        tripId,
    } = action.meta;

    const {
        [tripId]: _tripIdToRemove,
        ...updatedTrips
    } = state.trips;

    return {
        ...state,
        trips: updatedTrips,
    };
}

const handlers = {
    [types.SET_TRIP_ITINERARY]: _setTripItinerary,
    [types.SET_TRIP_INFORMATION]: _setTripInformation,
    [types.SET_TRIP_NOT_FOUND]: _setTripNotFound,
    [types.SET_TRIPS]: _setTrips,
    [types.UPDATE_TRIP]: _updateTrip,
    [types.REMOVE_TRIP]: _removeTrip,
};

function reducer(state = INITIAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];

        return handler(state, action);
    }

    return state;
}

export {
    INITIAL_STATE,
};

export default reducer;
